<template>
    <toolbar-option :message="message">
        <template slot="primary">
            <dropdown
                placeholder="Select a Tag"
                :options="htmlOptions"
                :value="htmlTag"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'html-tag',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'HTML Tag',
            htmlTag: 'h1',
        };
    },

    computed: {
        htmlOptions() {
            if (this.selectedElements.length < 1) return [];

            switch (this.selectedElements[0].templateType) {
                case 'a-heading':
                    return [
                        { text: 'h1', value: 'h1' },
                        { text: 'h2', value: 'h2' },
                        { text: 'h3', value: 'h3' },
                        { text: 'h4', value: 'h4' },
                        { text: 'h5', value: 'h5' },
                        { text: 'h6', value: 'h6' },
                    ];
                case 'Organism':
                    return [
                        { text: 'article', value: 'article' },
                        { text: 'aside', value: 'aside' },
                        { text: 'div', value: 'div' },
                        { text: 'footer', value: 'footer' },
                        { text: 'header', value: 'header' },
                        { text: 'main', value: 'main' },
                        { text: 'nav', value: 'nav' },
                        { text: 'section', value: 'section' },
                    ];
                case 'flex-placeholder':
                    return [
                        { text: 'empty', value: '' },
                        { text: 'article', value: 'article' },
                        { text: 'aside', value: 'aside' },
                        { text: 'div', value: 'div' },
                        { text: 'footer', value: 'footer' },
                        { text: 'header', value: 'header' },
                        { text: 'main', value: 'main' },
                        { text: 'nav', value: 'nav' },
                        { text: 'section', value: 'section' },
                    ];
                default:
                    return [];
            }
        },

        message() {
            if (this.selectedElements[0].templateType === 'flex-placeholder') {
                return 'Setting an HTML Tag on a drop zone will surround the drop zone with a wrapping HTML Tag. Accessibility Options will also be applied to this wrapper.';
            }
            return '';
        },
    },

    methods: {
        onInput(tagNew) {
            this.htmlTag = tagNew;

            this.selectedElements.forEach((element) => {
                element.tagNew = tagNew;
            });

            this.onOptionChange(tagNew);
        },

        onSelectedElement() {
            const element = this.selectedElements[0];

            this.htmlTag = element.tagNew || element.tagDefault;
        },
    },
};
</script>
